import type { RequireAtLeastOne } from 'type-fest'
import type { BuiltSource } from '@velasca/types'
import { setQueryParams } from './setQueryParams'

interface Size {
  width: number
  dpr: number
}

/**
 * It takes a source URL and a list of sizes and returns a list of sources.
 *
 * @param src - The original image URL.
 * @param sizes - An array of objects that contain the width and dpr
 * of the image. The provided array cannot be empty.
 */
export const buildDprSources = (
  src: string,
  sizes: RequireAtLeastOne<Size[], 0>,
): BuiltSource[] => {
  return sizes.map(({ width, dpr }) => {
    const imageUrl = setQueryParams(src, [
      { name: 'width', value: width.toString() },
    ])

    return {
      src: imageUrl.toString(),
      width: `${dpr.toString()}x`,
    }
  })
}
